var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import * as singleSpa from 'single-spa';

/**
 * Service to safely manage single-spa navigation and history patching.
 *
 * This service provides a safe wrapper around single-spa's start() method
 * and prepares for a future custom history patching solution to replace
 * single-spa's built-in history patching that was removed in v6.
 */
let NavigationShimService = (_class = class NavigationShimService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _defineProperty(this, "originalPushState", null);
    _defineProperty(this, "originalReplaceState", null);
    _defineProperty(this, "isExecuting", false);
  }
  /**
   * Stores the original window.history.pushState and replaceState functions
   * in global variables if they don't exist yet.
   *
   * This ensures we can restore the original functions later if needed.
   */
  storeOriginalHistoryFunctions() {
    if (!this.originalPushState) {
      this.originalPushState = window.history.pushState.bind(window.history);
    }
    if (!this.originalReplaceState) {
      this.originalReplaceState = window.history.replaceState.bind(window.history);
    }
  }

  /**
   * Patches the history API to work with single-spa.
   */
  addHistoryPatching() {
    try {
      // Store original history functions before starting single-spa
      this.storeOriginalHistoryFunctions();
      singleSpa.patchHistoryApi();
    } catch {
      // don't do anything
    }
  }

  /**
   * Safely starts single-spa. Can be called multiple times without throwing errors.
   *
   * In single-spa v6, start() can throw if called multiple times, so we track
   * the state and only call it once.
   */
  start() {
    try {
      this.addHistoryPatching();
      singleSpa.start();
    } catch {
      // don't do anything
    }
  }

  /**
   * Generic method that executes a callback with original history functions restored.
   * Useful for any navigation operations that need to bypass single-spa's history patching.
   *
   * @param callback - A function that returns a value or promise
   * @returns The result of the callback (Promise if callback is async)
   */
  async executeWithOriginalHistory(callback) {
    // Prevent concurrent executions
    if (this.isExecuting) {
      return callback();
    }
    this.isExecuting = true;
    const currentPushState = window.history.pushState;
    const currentReplaceState = window.history.replaceState;

    // Temporarily restore original history functions
    if (this.originalPushState) {
      window.history.pushState = this.originalPushState;
    }
    if (this.originalReplaceState) {
      window.history.replaceState = this.originalReplaceState;
    }
    try {
      const result = await callback();
      return result;
    } finally {
      // Restore on sync error
      // Restore on sync error
      // eslint-disable-next-line require-atomic-updates
      window.history.pushState = currentPushState;
      // eslint-disable-next-line require-atomic-updates
      window.history.replaceState = currentReplaceState;
      this.isExecuting = false;
    }
  }

  /**
   * Wrapper for Ember router's transitionTo that temporarily restores original pushState
   * before calling the router method, preventing single-spa's history patching from interfering.
   */
  // TODO: update to use executeWithOriginalHistory once it can handle async callbacks
  transitionTo(...args) {
    // Temporarily restore original pushState
    const currentPushState = window.history.pushState;
    if (this.originalPushState) {
      window.history.pushState = this.originalPushState;
    }
    try {
      return this.router.transitionTo(...args);
    } finally {
      // Restore single-spa's patched pushState
      window.history.pushState = currentPushState;
    }
  }

  /**
   * Wrapper for Ember router's replaceWith that temporarily restores original replaceState
   * before calling the router method, preventing single-spa's history patching from interfering.
   */
  // TODO: update to use executeWithOriginalHistory once it can handle async callbacks
  replaceWith(...args) {
    // Temporarily restore original replaceState
    const currentReplaceState = window.history.replaceState;
    if (this.originalReplaceState) {
      window.history.replaceState = this.originalReplaceState;
    }
    try {
      return this.router.replaceWith(...args);
    } finally {
      // Restore single-spa's patched replaceState
      window.history.replaceState = currentReplaceState;
    }
  }
  reset() {
    this.originalPushState = null;
    this.originalReplaceState = null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { NavigationShimService as default };